import axios from "axios";
import { url } from "../../api";
import { toast } from "react-toastify";

export const signUp = (user) => {
  return (dispatch) => {
    axios
      .post(`${url}/signup`, user)
      .then((token) => {
        console.log("token === ",token)
        localStorage.setItem("token", token.data);
        dispatch({
          type: "SIGN_UP",
          token: token.data,
        });
      })
      .catch((error) => {
        console.log(error.response);
        toast.error(error.response?.data, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  };
};

export const signIn = (speudo, passwd) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${url}/auth/login`, { speudo, passwd });
      const data = response.data;

      if (data.actif === false) {
        toast.error("Votre compte est désactivé. Veuillez contacter l'administrateur.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return { type: "SIGNIN_DISABLED", payload: data };
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data));

      dispatch({
        type: "SIGN_IN",
        token: data.token,
        auth: data,
      });

      return { type: "SIGNIN_SUCCESS", payload: data };

    } catch (error) {
      toast.error(error.response?.data?.error || "Erreur de connexion", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      return { type: "SIGNIN_ERROR", payload: error.response?.data };
    }
  };
};


export const signOut = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_TODOS",
    });
    
    dispatch({
      type: "SIGN_OUT",
    });

  };
};

export const loadUser = () => {
  return (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      dispatch({
        type: "USER_LOADED",
        token,
      });
    } else return null;
  };
};